/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TipoPraticaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeleteTipoPraticaConvenzioneRequestParams {
    id: string;
    version: number;
}

export interface DownloadTipoPraticaConvenzioneRequestParams {
    id: string;
}

export interface UploadTipoPraticaConvenzioneRequestParams {
    id: string;
    version: number;
    file: Blob;
}


export interface TipoPraticaConvenzioneControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Rimuove il PDF di convenzione del bando.
     * Query param \&#39;version\&#39; (version della policy). 404 se il bando non ha un file; 409 version stale.
     * @endpoint delete /api/v1/gestione/tipi-pratica/{id}/policy/convenzione
* @param requestParameters
     */
    deleteTipoPraticaConvenzione(requestParameters: DeleteTipoPraticaConvenzioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Scarica il PDF di convenzione del bando.
     * 404 se il bando non ha un file di convenzione.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id}/policy/convenzione/download
* @param requestParameters
     */
    downloadTipoPraticaConvenzione(requestParameters: DownloadTipoPraticaConvenzioneRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Carica (o sostituisce) il PDF di convenzione del bando.
     * Multipart: campo \&#39;version\&#39; (version della policy) + part \&#39;file\&#39; (PDF, max 10 MB). 422 se il PDF non e\&#39; valido o se il bando ha gia\&#39; un link di convenzione (tipopratica_convenzione_link_e_file); 409 version stale.
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/policy/convenzione
* @param requestParameters
     */
    uploadTipoPraticaConvenzione(requestParameters: UploadTipoPraticaConvenzioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

}
